export let flagTitle = "mGXuTc";
export let unflagTitle = "lSeUid";
export let markCompleteTitle = "K1mLvc";
export default {flagTitle,unflagTitle,markCompleteTitle};